import { render, staticRenderFns } from "./PrintableFeedbackQuestion.vue?vue&type=template&id=42d5ab56&"
import script from "./PrintableFeedbackQuestion.vue?vue&type=script&lang=js&"
export * from "./PrintableFeedbackQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports